import { useState } from "react";

interface WholesaleFaqItemProps {
  question: string;
  answer: string;
}

const WholesaleFaqItem = ({ question, answer }: WholesaleFaqItemProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`bg-white rounded-xl border transition-all duration-200 overflow-hidden ${
        open ? "border-[#C41E3A]/30" : "border-gray-100"
      }`}
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer group"
      >
        <span className={`text-sm font-semibold leading-snug pr-4 transition-colors ${open ? "text-[#C41E3A]" : "text-gray-900 group-hover:text-[#C41E3A]"}`}>
          {question}
        </span>
        <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${open ? "bg-[#C41E3A] text-white rotate-45" : "bg-gray-100 text-gray-500 group-hover:bg-[#C41E3A]/10 group-hover:text-[#C41E3A]"}`}>
          <i className="ri-add-line text-sm"></i>
        </div>
      </button>
      {open && (
        <div className="px-6 pb-5">
          <div className="h-px bg-gray-100 mb-4"></div>
          <p className="text-sm text-gray-600 leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
};

export default WholesaleFaqItem;